let routerNames = {
    route: {
        main: 'route',
    },
    dashboard: {
        main: 'Dashboard',
    },
    dealer: {
        main: 'Dealer',
    },
    help: {
        main: 'Help',
    },
    app: {
        user: {
            edit: {
                main: 'App.user.edit'
            }
        }
    },
    users: {
        main: 'Users',
        actions: 'Users_actions',
        history: 'Users.history',
        edit: {
            main: 'Users.edit',
            password: 'Users.change-password',
            create: 'Users.create',
            setup_dns: 'Users.setup-dns',
            customize: 'Users.edit.customize',
            customizeBackground: 'Users.edit.customize.background',
        }
    },
    md: {
        main: 'MD',
        fleet: {
            main: 'MD.fleet',
            widget: 'MD.fleet.widget',
        },
        vision: {
            main: 'MD.vision',
            video: 'MD.vision.video',
            groupId: {
                main: 'MD.vision.groupId',
                video: 'MD.vision.groupId.video',
            }
        },
        xCargo: {
            main: 'MD.xCargo'
        }
    },
    units: {
        main: 'Units',
        id: 'Units.id',
        fastGeozone: {
            main: 'Units.fastGeozone',
            group: 'Units.fastGeozone.group',
        },
        all: {
            main: 'Units.all',
            info: 'Units.all.info',
        },
        lite: 'Units.lightView',
        locator: 'Units.locator',
        chat: 'Units.chat',
        history: 'Units.history',
        commands: {
            main: 'Units.command',
            group: 'Units.groupCommand',
        },
        info: 'Units.info',
        edit: {
            main: 'Units.edit',
            group: 'Units.groupEdit',
            create: 'Units.create',
        },
        video: {
            main: 'Units.video',
            live: 'Units.liveVideo',
            event: 'Units.video-event',
            request: 'Units.video-request',
        },
        type: {
            xtrack: {
                main: 'Units.xtrack',
                info: 'Units.xtrack.info',
                edit: 'Units.xtrack.edit',
                fastGeozone: 'Units.xtrack.fastGeozone',
                sensors: 'Units.xtrack.sensors',
                track: 'Units.xtrack.track',
                event: 'Units.xtrack.event',
                date: 'Units.xtrack.date',
                sharedLinks: 'Units.xtrack.shared-links',
            },
            m2m: {
                main: 'Units.m2m',
                info: 'Units.m2m.info',
                edit: 'Units.m2m.edit',
                fastGeozone: 'Units.m2m.fastGeozone',
                sensors: 'Units.m2m.sensors',
                track: 'Units.m2m.track',
                event: 'Units.m2m.event',
                date: 'Units.m2m.date',
                sharedLinks: 'Units.m2m.shared-links',
            },
            m2m_chassis: {
                main: 'Units.m2m_chassis',
                info: 'Units.m2m_chassis.info',
                track: 'Units.m2m_chassis.track',
                sensors: 'Units.m2m_chassis.sensors',
                event: 'Units.m2m_chassis.event',
                liveVideo: 'Units.m2m_chassis.live-video',
                videoEvent: 'Units.m2m_chassis.video-event',
                videoEventUnitTracking: 'Units.m2m_chassis.video-event.unit-tracking',
                videoRequest: 'Units.m2m_chassis.video-request',
                videoRequestUnitTracking: 'Units.m2m_chassis.video-request.unit-tracking',
                date: 'Units.m2m_chassis.date',
                sharedLinks: 'Units.m2m_chassis.shared-links',
            },
            xvision: {
                main: 'Units.xvision',
                info: 'Units.xvision.info',
                edit: 'Units.xvision.edit',
                fastGeozone: 'Units.xvision.fastGeozone',
                liveVideo: 'Units.xvision.live-video',
                event: 'Units.xvision.event',
                videoEvent: 'Units.xvision.video-event',
                videoRequest: 'Units.xvision.video-request',
                sensors: 'Units.xvision.sensors',
                snapshots: 'Units.xvision.snapshots',
                date: 'Units.xvision.date',
                track: 'Units.xvision.track',
                smartSearch: 'Units.xvision.smartSearch',
                sharedLinks: 'Units.xvision.shared-links',
                timeCapsule: {
                    main: 'Units.timeCapsule',
                    date: 'Units.timeCapsule.date',
                    video: 'Units.timeCapsule.video',
                },
            },
            pro_cargo_vision: {
                main: 'Units.proCargoVision',
                info: 'Units.proCargoVision.info',
                edit: 'Units.proCargoVision.edit',
                fastGeozone: 'Units.proCargoVision.fastGeozone',
                liveVideo: 'Units.proCargoVision.live-video',
                event: 'Units.proCargoVision.event',
                videoEvent: 'Units.proCargoVision.video-event',
                videoRequest: 'Units.proCargoVision.video-request',
                sensors: 'Units.proCargoVision.sensors',
                snapshots: 'Units.proCargoVision.snapshots',
                track: 'Units.proCargoVision.track',
                date: 'Units.proCargoVision.date',
                sharedLinks: 'Units.proCargoVision.shared-links',
            },
            xpower: {
                main: 'Units.xpower',
                info: 'Units.xpower.info',
                edit: 'Units.xpower.edit',
                fastGeozone: 'Units.xpower.fastGeozone',
                sensors: 'Units.xpower.sensors',
                control: 'Units.xpower.control',
                analytics: 'Units.xpower.analytics',
                history: 'Units.xpower.history',
                date: 'Units.xpower.date',
                sharedLinks: 'Units.xpower.shared-links',
            },
            xcool: {
                main: 'Units.xcool',
                info: 'Units.xcool.info',
                edit: 'Units.xcool.edit',
                fastGeozone: 'Units.xcool.fastGeozone',
                reefer: 'Units.xcool.reefer',
                event: 'Units.xcool.event',
                date: 'Units.xcool.date',
                sharedLinks: 'Units.xcool.shared-links',
            },
            xgrafana: {
                main: 'Units.xgrafana',
                info: 'Units.xgrafana.info',
                edit: 'Units.xgrafana.edit',
                fastGeozone: 'Units.xgrafana.fastGeozone',
                sensors: 'Units.xgrafana.sensors',
                event: 'Units.xgrafana.event',
                date: 'Units.xgrafana.date',
                sharedLinks: 'Units.xgrafana.shared-links',
            },
            xlink: {
                main: 'Units.xlink',
                info: 'Units.xlink.info',
                edit: 'Units.xlink.edit',
                fastGeozone: 'Units.xlink.fastGeozone',
                event: 'Units.xlink.event',
                date: 'Units.xlink.date',
                sharedLinks: 'Units.xlink.shared-links',
            },
            obd: {
                main: 'Units.OBD',
                info: 'Units.OBD.info',
                edit: 'Units.OBD.edit',
                event: 'Units.OBD.event',
                videoEvent: 'Units.OBD.video-event',
                videoRequest: 'Units.OBD.video-request',
                fastGeozone: 'Units.OBD.fastGeozone',
                map: 'Units.OBD.map',
                date: 'Units.OBD.date',
                track: 'Units.OBD.track',
                sharedLinks: 'Units.OBD.shared-links',
            },
            xbles: {
                main: 'Units.xbles',
                info: 'Units.xbles.info',
                edit: 'Units.xbles.edit',
                event: 'Units.xbles.event',
                videoEvent: 'Units.xbles.video-event',
                videoRequest: 'Units.xbles.video-request',
                fastGeozone: 'Units.xbles.fastGeozone',
                map: 'Units.xbles.map',
                date: 'Units.xbles.date',
                track: 'Units.xbles.track',
                sharedLinks: 'Units.xbles.shared-links',
                id: {
                    main: 'Units.xbles.id',
                },
            },
        },
        track: {
            main: "Units.track",
            xid: "Units.track.xid",
            event_xid: "Units.track.event.xid"
        }
    },
    units_groups: {
        main: 'UnitsGroups',
        id: 'UnitsGroups.id',
        map: 'UnitsGroups.map',
        edit: 'UnitsGroups.edit'
    },
    services: {
        main: 'Services',
        id: 'Services.id',
        list: 'Services.list',
        service: 'Services.service'
    },
    tracks: {
        main: 'Tracks',
        lite: 'Tracks.lightView',
        date: 'Tracks.date',
        unit: {
            main: 'Tracks.unit',
            asset: {
                main: 'Tracks.unit.asset',
                index: 'Tracks.unit.asset.index'
            },
        },
        xid: 'Tracks.xid',
        event_xid: 'Tracks.event-xid',
        move_on_track: 'Tracks.moveOnTrack',
        video: {
            event: 'Tracks.video-event',
            request: 'Tracks.video-request',
        }
    },
    notificationsevents: {
        main: 'NotificationsEvents',
        lite: 'NotificationsEvents.lightView',
        date: 'NotificationsEvents.date',
        filter: 'NotificationsEvents.filter',
        edit: {
            main: 'NotificationsEvents.edit',
        },
        popup: {
            main: 'NotificationsEvents.popup',
        }
    },
    geoitems: {
        main: 'Geoitems',
        id: 'Geoitems.id',
        lite: 'Geoitems.lightView',
        edit: {
            main: 'Geoitems.edit',
            //editPopup: 'Geoitems.geozones.edit.popup',
        }
    },
    object_changes: {
        main: 'ObjectsChanges',
    },
    recycle_bin: {
        main: 'RecycleBin',
        restore: 'RecycleBin.restore',
        edit: {
            unit: 'RecycleBin.unit-edit',
        },
        history: {
            unit: 'RecycleBin.unit-history',
            user: 'RecycleBin.user-history',
        }
    },
    statistics: {
        main: 'Statistics',
        statement: 'Statistics.statement',
        mileage: 'Statistics.mileage',
    },
    analytics: {
        main: 'analytics'
    },
    routes: {
        main: 'Routes',
    },
    locator: {
        main: 'Locator',
    },
    alarms: {
        main: 'Alarms',
    },
    dashboard_gauges: {
        main: 'DashboardGauges',
    },
    fuel: {
        main: 'Fuel',
    },
    fuel_cards: {
        main: 'FuelCards',
    },
    maintenance: {
        main: 'Maintenance',
    },
    personnel: {
        main: 'Personnel',
    },
    reports: {
        main: 'Reports',
        template: 'Reports.template',
        system: 'Reports.system',
        mongo: 'Reports.mongo',
    },
    video: {
        main: 'Video',
    },
    shipment: {
        main: 'Shipment',
        id: 'Shipment.id',
        map: 'Shipment.map',
        edit: 'Shipment.edit',
        editView: 'Shipment.editView',
        packageId: 'Shipment.packageId',
        packageIdEdit: 'Shipment.packageIdEdit',
        packageMap: 'Shipment.packageMap',
    },
    shipments_locator: {
        main: 'ShipmentsLocator',
        info: 'ShipmentsLocator.info',
    },
}
let defaultGrafanaSensors = {
    temperature: {
        panelId: 3,
        type: 'default',
    },
    battery: {
        panelId: 4,
        type: 'default',
    },
    humidity: {
        panelId: 6,
        type: 'default',
    },
    light: {
        panelId: 7,
        type: 'default',
    },
    shock: {
        panelId: 8,
        type: 'default',
    },
    fuel_level: {
        panelId: 9,
        type: 'default',
    },
    fuel_used: {
        panelId: 10,
        type: 'default',
    },
    fuel_economy: {
        panelId: 11,
        type: 'default',
    },
    cumulative_fuel_economy: {
        panelId: 12,
        type: 'default',
    },
    speed: {
        panelId: 13,
        type: 'default',
    },
    rpm: {
        panelId: 14,
        type: 'default',
    },
    mileage: {
        panelId: 15,
        type: 'default',
    },
    idling_duration: {
        panelId: 21,
        type: 'default',
    },
    main_power: {
        panelId: 22,
        type: 'default',
    },
    throttle_position: {
        panelId: 23,
        type: 'default',
    },
}
const consts = {
    testSites: {
        portal: 'test.xgps.us',
        admin: 'admintest.xgps.us',
    },
    timeoutReadyComponent: 300,
    querySettings: {
        filter: {'filter[changed]': 600},
        pageSize: 300,
        maxPages: 8,
        // unitsPageSize: 100,
    },
    routerNames,
    customServices: [
    ],
    locatorTimeout: [
        {id: 'hours', name: 'Hours', sort: 1},
        {id: 'days', name: 'Days', sort: 2},
        {id: 'weeks', name: 'Weeks', sort: 3},
        {id: 'months', name: 'Months', sort: 4},
    ],
    templates: {
        unitLite: {
            routeName: routerNames.units.lite,
            extensions: {
                byUnitHwType: ['xpower'],// xlink - ???
            },
        },
        // tracksLite: {
        //     routeName: routerNames.tracks.lite,
        //     extensions: {},
        // },
        // geoitemsLite: {
        //     routeName: routerNames.geoitems.lite,
        //     extensions: {},
        // },
        // notificationseventsLite: {
        //     routeName: routerNames.notificationsevents.lite,
        //     extensions: {},
        // }
    },
    grafana: {
        sensors: {
            dashboardUrl: '/d-solo/cfe443fa-ff54-4057-abe2-abc7734d4d22/sensors',
            defaultSettings: {
                panelId: 2,
                type: 'default'
            },
            hw_type: {
                default: defaultGrafanaSensors,
            }
        },
    },
    shortWidth: 690,
    typesForTrackByPoints: ['asset'],
    map: {
        center: [25.761681, -80.191788],
    },
    dealer_shop: 'https://83fbbd-2.myshopify.com/',
    shopify: {
        dealer: {
            domain: '83fbbd-2.myshopify.com',
            storefrontAccessToken: '97f09cc3f6cdb53725424cffe62d69ff'
        },
        client: {
            domain: '83fbbd-2.myshopify.com',
            storefrontAccessToken: '97f09cc3f6cdb53725424cffe62d69ff'
        },
    },
    customizeColorThemes: [
        {id: 'blue',   name: 'Blue' },
        {id: 'orange', name: 'Orange' },
        {id: 'green',  name: 'Green' },
        {id: 'purple', name: 'Purple' }
    ],
    units_of_measure:['imperial','metric'],
    customizeDomains: [
        {id: 'portal', label: 'Portal', disabled: false, disabled_SuperAdmin: false},
        {id: 'admin', label: 'Admin', disabled: true, disabled_SuperAdmin: false},
        {id: 'hw', label: 'HW', disabled: true, disabled_SuperAdmin: false},
    ],
    entri: {
        add_domains: [
            {id: 'portal', label: 'Portal', def_value: 'portal'},
            {id: 'admin', label: 'Admin', def_value: 'admin'},
            {id: 'hw', label: 'HW', def_value: 'hw'},
        ]
    },
    recyclebin_time_left: 60*24*3600,
    menus: {
        portal: [
            {id: "units", name: routerNames.units.main, title: ("menu.Units"), icon: "menu__car"},
            {id: "md",    name: routerNames.md.main,   title: ("menu.MD"), icon: "menu__md"},
            {id: "tracks", name: routerNames.tracks.main, title: ("menu.Tracks"), icon: "menu__tracks"},
            {id: "geoitems", name: routerNames.geoitems.main, title: ("menu.Geoitems"), icon: "menu__geoitems"},
            {id: "notificationsevents", name: routerNames.notificationsevents.main, title: ("menu.Notice"), icon: "menu__notifications"},
            {id: "reports",         name: routerNames.reports?.main,        title: ("menu.Reports"), icon: "menu__reports"},
            {id: "help", name: routerNames.help.main, title: ('menu.Help'), icon: "menu__help"},
            // {id: "dashboard", name: routerNames.dashboard.main, title: 'menu.Dashboard', icon: "menu__statistic"},
            // {id: "dealer", name: routerNames.dealer.main, title: ("menu.Dealer"), icon: "menu__dealer"},
            {id: "shipment", name: routerNames.shipment.main, title: ("menu.Shipment"), icon: "menu__shipment", hide_menu_enable: true},
            // {id: "analytics", name: routerNames.analytics.main, title: ('menu.Analytics'), icon: "menu__analytics"},
            // {id: "test", name: routerNames.test.main, title: ('menu.TestPage'), icon: "menu__test"},
        ],
        admin: [
            {id: "statistics", name: routerNames.statistics.main, title: ('menu.Dashboard'), icon: "menu__dashboard"},
            {id: "users", name: routerNames.users.main, title: ("menu.Users"), icon: "menu__personnel"},
            {id: "units", name: routerNames.units.main, title: ("menu.Units"), icon: "menu__car"},
            {id: "recycle-bin", name: routerNames.recycle_bin.main, title: ("menu.Recycle Bin"), icon: "menu__delete"},
            {id: "user-actions", name: routerNames.users.actions, title: ("menu.User actions"), icon: "menu__history"},
            // {id: "objs-changes", name: routerNames.object_changes.main, title: ("menu.User actions"), icon: "menu__history"},
            // {id: "dealer", name: routerNames.dealer.main, title: ("menu.Dealer"), icon: "menu__dealer"},
            // {id: "help", name: routerNames.help.main, title: ('menu.Help'), icon: "menu__help"},
            // {id: "test",            name: routerNames.test.main,           title: ('menu.TestPage'), icon: "menu__test"},
        ],
        mainSize: 9,
    },
    defaultSettingsLayers: {
        units: {visible: false, showInList: true, showLayer: true},
        geoitems: {visible: false, showInList: true, showLayer: true},
    },
    FilterSearchLists: {
        Units: {
            signals: [
                {id: 'on', name: ('ON line'), translate: ('Units.signals.ON line'), icon: 'common__car'},
                {id: 'off', name: ('OFF line'), translate: ('Units.signals.OFF line'), icon: 'common__car'},
            ],
            movements: [
                {id: 'moving', name: ('Moving'), translate: ('Units.movements.Moving'), icon: 'common__car'},
                {id: 'stopped', name: ('Stopped'), translate: ('Units.movements.Stopped'), icon: 'common__car'},
                {id: 'ignition', name: ('Ignition on'), translate: ('Units.movements.Ignition on'), icon: 'common__car'},
            ],
            car_icons: [
                {id: 'map__car_type_sedan', name: ('Sedan'), translate: ('Units.icons.Sedan'), group:'Dynamic', isColored: true},
                {id: 'map__car_type_pickup', name: ('Pickup'), translate: ('Units.icons.Pickup'), group:'Dynamic', isColored: true},
                {id: 'map__car_type_truck', name: ('Truck'), translate: ('Units.icons.Truck'), group:'Dynamic', isColored: true},
                {id: 'map__car_type_motorbike', name: ('Motorbike'), translate: ('Units.icons.Motorbike'), group:'Dynamic', isColored: true},
                {id: 'map__car_type_container', name: ('Container'), translate: ('Units.icons.Container'), group:'Dynamic', isColored: true},
                {id: 'map__car_type_flatbed', name: ('Flatbed'), translate: ('Units.icons.Flatbed'), group:'Dynamic', isColored: true},
                {id: 'map__car_type_reefer', name: ('Reefer'), translate: ('Units.icons.Reefer'), group:'Dynamic', isColored: true},
                {id: 'map__car_type_trailer', name: ('Trailer'), translate: ('Units.icons.Trailer'), group:'Dynamic', isColored: true},
                {id: 'map__car_type_taxi', name: ('Taxi'), translate: ('Units.icons.Taxi'), group:'Static', isColored: false},
                {id: 'map__car_type_police', name: ('Police'), translate: ('Units.icons.Police'), group:'Static', isColored: false},
                {id: 'map__car_type_ambulance', name: ('Ambulance'), translate: ('Units.icons.Ambulance'), group:'Static', isColored: false},
                {id: 'map__car_type_k9', name: ('K9 Dog'), translate: ('Units.icons.K9 Dog'), group:'Static', isColored: false, disabledRotate: true},
                {id: 'map__car_type_police-car', name: ('Police Car'), translate: ('Units.icons.Police Car'), group:'Static', isColored: false, disabledRotate: true},
                {id: 'map__car_type_law-men', name: ('Law Enforcement'), translate: ('Units.icons.Law Enforcement'), group:'Static', isColored: false, disabledRotate: true},
                {id: 'map__car_type_law-women', name: ('Law Enforcement Woman'), translate: ('Units.icons.Law Enforcement Woman'), group:'Static', isColored: false, disabledRotate: true},
                {id: 'map__car_type_paramedics', name: ('Paramedics'), translate: ('Units.icons.Paramedics'), group:'Static', isColored: false, disabledRotate: true},
                {id: 'map__car_type_paramedics-women', name: ('Paramedics Woman'), translate: ('Units.icons.Paramedics Woman'), group:'Static', isColored: false, disabledRotate: true},
                {id: 'map__car_type_fire-fighter', name: ('Fire Fighter'), translate: ('Units.icons.Fire Fighter'), group:'Static', isColored: false, disabledRotate: true},
                {id: 'map__car_type_fire-fighter-woman', name: ('Fire Fighter Woman'), translate: ('Units.icons.Fire Fighter Woman'), group:'Static', isColored: false, disabledRotate: true},
            ],
            camera: [
                {id: 'all', name: 'All Cameras', translate: 'Units.camera.All Cameras', icon: 'camera-online', color: 'gray'},
                {id: 'online', name: 'Cameras Online', translate: 'Units.camera.Cameras Online', icon: 'camera-online', color: '#0ec900'},
                {id: 'offline', name: 'Cameras Offline', translate: 'Units.camera.Cameras Offline', icon: 'camera-offline', color: 'red'},
            ],
            types: [
                {id: 'truck', name: ('Truck'), translate: ('Units.types.Truck'), icon: 'unit_type_truck', filterByTypes: true},
                {id: 'container', name: ('Container'), translate: ('Units.types.Container'), icon: 'unit_type_container', filterByTypes: true},
                {id: 'flatbed', name: ('Flatbed'), translate: ('Units.types.Flatbed'), icon: 'unit_type_flatbed', filterByTypes: true},
                {id: 'reefer', name: ('Reefer'), translate: ('Units.types.Reefer'), icon: 'unit_type_reefer', filterByTypes: true},
                {id: 'trailer', name: ('Trailer'), translate: ('Units.types.Trailer'), icon: 'unit_type_reefer', filterByTypes: true},
                // {id: 'complex', name: ('Complex'), translate: ('Units.types.Complex'), icon: 'common__complex'},
                // {id: 'boat', name: ('Boat'), translate: ('Units.types.Boat'), icon: 'common__boat'},
                // {id: 'bus', name: ('Bus'), translate: ('Units.types.Bus'), icon: 'common__bus'},
                // {id: 'car', name: ('Car'), translate: ('Units.types.Car'), icon: 'common__car'},
                // {id: 'dry trailer', name: ('Dry Trailer'), translate: ('Units.types.Dry Trailer'), icon: 'common__dry_trailer'},
                // {id: 'engine', name: ('Engine'), translate: ('Units.types.Engine'), icon: 'common__engine'},
                // {id: 'fuel tank', name: ('Fuel Tank'), translate: ('Units.types.Fuel Tank'), icon: 'common__fuel_tank'},
                // {id: 'fuel tanker', name: ('Fuel Tanker'), translate: ('Units.types.Fuel Tanker'), icon: 'common__fuel_tanker'},
                // {id: 'generator', name: ('Generator'), translate: ('Units.types.Generator'), icon: 'common__generator'},
                // {id: 'jet ski', name: ('Jet Ski'), translate: ('Units.types.Jet Ski'), icon: 'common__jet_ski'},
                // {id: 'motorcycle', name: ('Motorcycle'), translate: ('Units.types.Motorcycle'), icon: 'common__motorcycle'},
                // {id: 'plant machine', name: ('Plant Machine'), translate: ('Units.types.Plant Machine'), icon: 'common__plant_machine'},
                // {id: 'pump', name: ('Pump'), translate: ('Units.types.Pump'), icon: 'common__pump'},
                // {id: 'rv', name: ('RV'), translate: ('Units.types.RV'), icon: 'common__rv'},
                // {id: 'reefer gt', name: ('Reefer GT'), translate: ('Units.types.Reefer GT'), icon: 'common__reefer_gt'},
                // {id: 'reefer trailer', name: ('Reefer Trailer'), translate: ('Units.types.Reefer Trailer'), icon: 'common__reefer_trailer'},
                // {id: 'stationary unit', name: ('Stationary Unit'), translate: ('Units.types.Stationary Unit'), icon: 'common__stationary_unit'},
                // {id: 'tank', name: ('Tank'), translate: ('Units.types.Tank'), icon: 'common__tank'},
                // {id: 'tractor', name: ('Tractor'), translate: ('Units.types.Tractor'), icon: 'common__tractor'},
                // {id: 'train', name: ('Train'), translate: ('Units.types.Train'), icon: 'common__train'},
                // {id: 'truck', name: ('Truck'), translate: ('Units.types.Truck'), icon: 'common__truck'},
                // {id: 'van', name: ('Van'), translate: ('Units.types.Van'), icon: 'common__van'},
                // {id: 'water tanker', name: ('Water Tanker'), translate: ('Units.types.Water Tanker'), icon: 'common__water_tanker'},
            ],
        },
        Events: {
            types: [
                {id: 'lost connection', type: 'event', name: ('Lost connection'), translate: ('Events.types.Lost connection'), icon: 'notifications__lost-connection'},
                {id: 'low battery', type: 'event', name: ('Low battery'), translate: ('Events.types.Low battery'), icon: 'notifications__low-battery'},
                {id: 'max speed', type: 'event', name: ('Max speed'), translate: ('Events.types.Max speed'), icon: 'notifications__max-speed'},
                {id: 'input', type: 'event', name: ('Input alert'), translate: ('Events.types.Input alert'), icon: 'notifications__input'},
            ],
        },
        NotificationsEvents: {
            types: [
                // {id: '1', type: 'notification-event', name: ('Parameters control'), translate: ('NotifEvents.types.Parameters control'), icon: 'notifications__parameter_control'},
                {id: '2', type: 'notification-event', name: ('Entry into geosite'), translate: ('NotifEvents.types.Entry into geosite'), icon: 'notifications__geozone_entrance_control'},
                {id: '3', type: 'notification-event', name: ('Exit from geosite'), translate: ('NotifEvents.types.Exit from geosite'), icon: 'notifications__geozone_exit_control'},
                // {id: '4', type: 'notification-event', name: ('Approaching geopoint'), translate: ('NotifEvents.types.Approaching geopoint'), icon: 'notifications__approaching_geopoint'},
                // {id: '5', type: 'notification-event', name: ('Distance geopoint'), translate: ('NotifEvents.types.Distance geopoint'), icon: 'notifications__distance_geopoint'},
                // {id: '6', type: 'notification-event', name: ('Lost connection'), translate: ('NotifEvents.types.Lost connection'), icon: 'notifications__lost-connection'},
                // {id: '7', type: 'notification-event', name: ('Sensors control'), translate: ('NotifEvents.types.Sensors control'), icon: 'notifications__sensor_control'},
                // {id: '9', type: 'notification-event', name: ('Approaching object'), translate: ('NotifEvents.types.Approaching object'), icon: 'notifications__approaching_object'},
                // {id: '10', type: 'notification-event', name: ('Overspeeding by GIS'), translate: ('NotifEvents.types.Overspeeding by GIS'), icon: 'notifications__overspeeding_gis'},
                // {id: '11', type: 'notification-event', name: ('Maintenance'), translate: ('NotifEvents.types.Maintenance'), icon: 'notifications__maintenance'},
                // {id: '12', type: 'notification-event', name: ('Fuel control'), translate: ('NotifEvents.types.Fuel control'), icon: 'notifications__fuel_control'},
                // {id: '17', type: 'notification-event', name: ('Towing'), translate: ('NotifEvents.types.Towing'), icon: 'notifications__towing'},

                //{id: '8', type: 'notification-event', name: ('Track control'), translate: ('NotifEvents.types.Track control'), icon: 'notifications__'},
                //{id: '14', type: 'notification-event', name: ('Condition control'), translate: ('NotifEvents.types.Condition control'), icon: 'notifications__condition_control'},//???
                //{id: '14', type: 'notification-event', name: ('Condition control'), translate: ('NotifEvents.types.Condition control'), icon: 'notifications__movement'},
                //{id: '14', type: 'notification-event', name: ('Condition control'), translate: ('NotifEvents.types.Condition control'), icon: 'notifications__parking'},
                //'attribute' => 'type_condition', 'images' => ['movement' => 'movement','parking' => 'parking',],

                //{id: '15', type: 'notification-event', name: ('Control of presence inside of geozone'), translate: ('NotifEvents.types.Control of presence inside of geozone'), icon: 'notifications__'},
                //{id: '16', type: 'notification-event', name: ('Control of absence inside of geozone'), translate: ('NotifEvents.types.Control of absence inside of geozone'), icon: 'notifications__'},

            ],
        },
        VideoEvents: {
            types: [
                {id: 'video-event', type: 'video-event', name: ('Video event'), translate: ('VideoEvents.types.Video event'), icon: 'notifications__video-event'},
                // {id: 'ADAS', type: 'video-event', name: ('ADAS Video event'), translate: ('VideoEvents.types.ADAS Video event'), icon: 'notifications__video-event'},
                // {id: 'other', type: 'video-event', name: ('Other Video event'), translate: ('VideoEvents.types.other Video event'), icon: 'notifications__video-event'},
            ],
        },
        Shipment: {
            types: [
                {id: 'alerts', name: ('Alerts'), translate: ('Shipment.Alerts'), icon: 'shipment__documents'},
                // {id: 'documents', name: ('Documents'), translate: ('Shipment.Documents'), icon: 'shipment__documents'},
                // {id: 'box', name: ('Box'), translate: ('Shipment.Box'), icon: 'shipment__box'},
                // {id: 'container', name: ('Container'), translate: ('Shipment.Container'), icon: 'shipment__container'},
                // {id: 'pallet', name: ('Pallet'), translate: ('Shipment.Pallet'), icon: 'shipment__pallet'},
                // {id: 'food', name: ('Food'), translate: ('Shipment.Food'), icon: 'shipment__food'},
            ],
            groups: [
                {id: undefined, name: ('All Shipments'), translate: ('Shipment.All Shipments'), icon: 'common__car'},
                {id: 'single', name: ('Single Shipments'), translate: ('Shipment.Single Shipments'), icon: 'shipment'},
                {id: 'multiple', name: ('Multiple Shipments'), translate: ('Shipment.Multiple Shipments'), icon: 'shipments-package'},
            ],
            alerts: [
                {id: 'temperature', name: ('Temperature'), translate: ('Shipment.sensors.Temperature'), icon: 'shipment__documents'},
                {id: 'humidity', name: ('Humidity'), translate: ('Shipment.Humidity'), icon: 'shipment__box'},
                {id: 'light', name: ('Light'), translate: ('Shipment.sensors.Light'), icon: 'shipment__container'},
                {id: 'battery', name: ('Battery'), translate: ('Shipment.sensors.Battery'), icon: 'shipment__pallet'},
                {id: 'shock', name: ('Shock'), translate: ('Shipment.sensors.Shock'), icon: 'shipment__food'},
            ],
        }
    },
    ReeferTypes: [
        {
            'title': '-',
            'type':  '',
        },
        {
            'title': 'Thermo King',
            'type':  'thermo_king',
            'icon': 'reefer__king',
        },
        {
            'title': 'Carrier',
            'type':  'carrier',
            'icon': 'reefer__carrier',
        },
    ],
    Licenses: {
        params: [
            {days: 30, text: '1 month', color: '#FE6D23'},
            {days: 90, text: '3 months', color: '#FFB700'},
            {days: 180, text: '6 months', color: '#90C20B'},
            {days: 365, text: '1 year', color: '#01CB25'},
        ],
    },
    uploadError: {
        "invalidFileExtension": "Invalid file extension",
        "invalidMaxFileSize": "Invalid max file size",
        "invalidMixFileSize": "Invalid min file size"
    },
    unitsList: {
        useTypeForTemplate: ['xpower', 'xlink', 'xtag']
    },
    viewMACAddressByUnit: {
        type: ['ble_gateway', 'ble_tag'],
        hw_type: ['xtag', 'xlink'],
    },
    videoFormats: [
        {id: 'mp4',    name: 'mp4'},
        {id: 'images', name: 'images'},
    ],
    timeline: {
        eventpoint_width_px: 10,
        eventsgroup__width_px: 24+16,
        startsEnd__width_px: 24,
        movePointWidth: 2,//20,
        groupingTime: 3600 / 2,
        requestTimeFormat: 'HH:mm:ss',
        datetime_error: 'Current time is out of available time frame, video can\'t be requested',
        requestSeconds: [
            {id: 1, name: '0'},
            {id: 10, name: '10'},
            {id: 20, name: '20'},
            {id: 30, name: '30'},
            {id: 40, name: '40'},
            {id: 60, name: '60'},
            {id: 120, name: '120'},
        ],
    },
    timelineFilter: [
        {id: 'event', name: 'Events'},
        {id: 'command', name: 'Commands'},
        {id: 'video-event', name: 'Video events', video: true},
        {id: 'notification-event', name: 'Notifications events'},
        {id: 'video-request', name: 'Video requests', video: true},
    ],
    statusesObjects: [
        {id: 'moving',        color: '#2FC76B',  title: 'In Motion', class: 'status-unit-moving', z_index: 3},
        {id: 'driving',        color: '#2FC76B',  title: 'In Motion', class: 'status-unit-moving', z_index: 3},
        {id: 'parked',        color: '#0276F0',  title: 'Parked', class: 'status-unit-parked'},
        {id: 'parking',        color: '#0276F0',  title: 'Parked', class: 'status-unit-parked'},
        {id: 'driving-asset',        color: '#0276F0',  title: 'Asset Points', class: 'status-unit-moving'},
        {id: 'idling',        color: '#FD3939',  title: 'Idling', class: 'status-unit-idling', z_index: 2},
        {id: 'offline',       color: '#ff0000',  title: 'Offline', class: 'status-unit-offline'},
        {id: 'not_connection',color: '#000000',  title: 'Not connection', class: 'status-unit-not_connection'},
        {id: 'standBy',        color: '#FF8B1C',  title: 'Standby', class: 'status-unit-stand-by', z_index: 0},
        {id: 'alerts',        color: '#ff0000',  title: 'Alerts', class: 'status-shipment-alert', z_index: 3},
        {id: 'shipment',  color: 'transparent',  title: 'Shipment', class: 'status-shipment', z_index: 0},
        {id: 'shipment-time',  color: '#2FC76B',  title: 'Shipment time', class: 'status-shipment-time', z_index: 3},
        {id: 'shipment-start-delay',  color: 'orange',  title: 'Shipment Start Delay', class: 'status-shipment-start-delay', z_index: 3},
        {id: 'shipment-end-delay',  color: 'yellow',  title: 'Shipment End Delay', class: 'status-shipment-end-delay', z_index: 3},
        {id: 'loaded',        color: '#5FDC00',  title: 'Loaded', class: 'status-unit-stand-loaded', z_index: 1},
        {id: 'unloaded',        color: '#A0A0A0',  title: 'Unloaded', class: 'status-unit-stand-unloaded', z_index: 1},
        {id: 'report',        color: '#ff0000',  title: 'Claim process', class: 'status-unit-report', z_index: 4},
        {id: 'recovery-mode',  color: '#ff0000',  title: 'Recovery Mode', class: 'status-unit-recovery-mode', z_index: 4},
        {id: 'group-by-is_motion', color: '#FF8B1C',  title: 'Run Time', class: 'status-unit-is_motion', z_index: 4},
        {id: 'screenshots-interval', color: '#A0A0A0',  title: 'Screenshots', class: 'status-unit-screenshots-interval', z_index: 4, showValue: true},
    ],
}
export default consts